import styled from 'styled-components';
import Typography from '../Typography';
import { RadioBaseProps } from './Radio.types';

export const RadioRoot = styled.label<RadioBaseProps>`
  box-sizing: border-box;
  display: inline-flex;
  position: relative;
  flex-direction: column;
  margin: 0;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;

  color: ${({ disabled, theme }) => {
    const colors = theme[theme.color].Radio.text;

    return disabled ? colors.disabled : colors.normal;
  }};
`;

export const RadioButtonContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  position: relative;
  width: fit-content;

  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const RadioContainer = styled.div`
  display: inline-flex;
  width: 20px;
  height: 20px;
`;

export const RadioButton = styled.div<RadioBaseProps>`
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ disabled, error, theme }) => {
    const colors = theme[theme.color].Radio;

    if (error) return colors.error;
    if (disabled) return colors.disabled;
    return colors.normal;
  }};
  border-radius: 50%;
  transition: 200ms background-color ease-in-out;
`;

export const RadioButtonPoint = styled.span<RadioBaseProps>`
  height: 12px;
  width: 12px;
  opacity: ${({ checked }) => (checked ? 1 : 0)};
  background: ${({ theme, disabled, error }) => {
    const colors = theme[theme.color].Radio;

    if (error) return colors.error;
    if (disabled) return colors.disabled;
    return colors.normal;
  }};
  border-radius: 50%;
  transition: 200ms background-color ease-in-out;
`;

export const RadioButtonInput = styled.input`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;

export const StyledLabel = styled(Typography)`
  padding-left: 8px;
`;
